import { Box, Typography } from "@mui/material";
import type { JobStage, JobStatus } from "@/types/marketReport";
import { ReportStatusBadge } from "./ReportStatusBadge";

const STAGE_LABELS: Record<JobStage, string> = {
  parse_pdf: "Parsing PDF",
  extract_metadata: "Extracting metadata",
  create_sections: "Creating sections",
  extract_coverage_slices: "Extracting coverage",
  extract_metrics: "Extracting metrics",
  generate_embeddings: "Generating embeddings",
  finalize: "Finalizing",
};

export function JobProgressIndicator({
  stage,
  jobStatus,
  label,
}: {
  stage?: JobStage | null;
  jobStatus?: JobStatus;
  label?: string;
}) {
  const stageLabel = stage ? STAGE_LABELS[stage] : null;
  const badgeStatus = jobStatus ?? (stage ? "running" : "processing");

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
      <ReportStatusBadge status={badgeStatus} />
      {(label ?? stageLabel) ? (
        <Typography variant="body2" color="text.secondary">
          {label ?? stageLabel}
        </Typography>
      ) : null}
    </Box>
  );
}
